/* Outfit-Seite Navigazione: Filter (Übersicht), Größenwahl und Warenkorb (Detail), Galerie. Gebaut 01.10.2026 */
(function () {
  if (window.__navOutfit) return;
  window.__navOutfit = true;

  /* ---------- Geld im Shop-Format (wie der Liquid-Filter money) ---------- */
  var geldFormat = null;
  function formatieren(cents, format) {
    var n = (Number(cents) || 0) / 100;
    function f(dec, tausend, komma) {
      var teile = n.toFixed(dec).split('.');
      var g = teile[0], out = '';
      while (g.length > 3) { out = tausend + g.slice(-3) + out; g = g.slice(0, -3); }
      out = g + out;
      return dec ? out + komma + teile[1] : out;
    }
    var map = {
      amount: f(2, ',', '.'),
      amount_no_decimals: f(0, ',', '.'),
      amount_with_comma_separator: f(2, '.', ','),
      amount_no_decimals_with_comma_separator: f(0, '.', ','),
      amount_with_space_separator: f(2, ' ', ','),
      amount_no_decimals_with_space_separator: f(0, ' ', ',')
    };
    var res = format;
    Object.keys(map).forEach(function (k) {
      res = res.split('{{' + k + '}}').join(map[k]).split('{{ ' + k + ' }}').join(map[k]);
    });
    return res;
  }
  function geld(cents) {
    if (geldFormat === null) {
      var el = document.querySelector('[data-money-format]');
      geldFormat = el ? el.getAttribute('data-money-format') || '' : '';
    }
    if (geldFormat && geldFormat.indexOf('{{') > -1) return formatieren(cents, geldFormat);
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format((Number(cents) || 0) / 100);
  }
  function farbname(wert) { return String(wert || '').replace(/^[ ]*[0-9]+[ ]*-[ ]*/, ''); }
  function bildUrl(src, breite) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + breite;
  }
  function nachricht(el, text, ok) {
    if (!el) return;
    el.textContent = text || '';
    el.classList.toggle('is-ok', !!ok);
    el.hidden = !text;
  }

  /* ---------- Übersicht: Filter ---------- */
  function filtern(chip) {
    var root = chip.closest('[data-outfit-uebersicht]');
    if (!root) return;
    var wert = chip.getAttribute('data-wert') || '';
    root.querySelectorAll('[data-outfit-chip]').forEach(function (c) {
      c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
    });
    var sichtbar = 0;
    root.querySelectorAll('[data-outfit-karte]').forEach(function (k) {
      var a = (k.getAttribute('data-anlass') || '').split('|');
      var zeigen = !wert || a.indexOf(wert) > -1;
      k.hidden = !zeigen;
      if (zeigen) sichtbar++;
    });
    var leer = root.querySelector('[data-outfit-leer]');
    if (leer) leer.hidden = sichtbar > 0;
  }

  /* ---------- Detail: Teile ---------- */
  function teile(root) { return root ? Array.prototype.slice.call(root.querySelectorAll('[data-outfit-teil]')) : []; }
  function varianten(row) {
    if (!row.__v) {
      try { row.__v = JSON.parse(row.getAttribute('data-variants') || '[]'); } catch (e) { row.__v = []; }
    }
    return row.__v;
  }
  function auswahl(row) {
    var sel = [];
    row.querySelectorAll('[data-opt]').forEach(function (el) {
      sel[parseInt(el.getAttribute('data-index'), 10)] = el.value || '';
    });
    for (var i = 0; i < sel.length; i++) if (sel[i] == null) sel[i] = '';
    return sel;
  }
  function passt(v, sel, ohne) {
    for (var i = 0; i < sel.length; i++) {
      if (i === ohne) continue;
      if (sel[i] && v.options[i] !== sel[i]) return false;
    }
    return true;
  }
  function zeileAktualisieren(row) {
    if (row.classList.contains('is-vergriffen')) return;
    var vs = varianten(row);
    var sel = auswahl(row);

    row.querySelectorAll('select[data-opt]').forEach(function (s) {
      var idx = parseInt(s.getAttribute('data-index'), 10);
      Array.prototype.forEach.call(s.options, function (o) {
        if (!o.value) return;
        var ok = vs.some(function (v) { return v.available && v.options[idx] === o.value && passt(v, sel, idx); });
        o.disabled = !ok;
        o.textContent = o.value + (ok ? '' : ' - ausverkauft');
      });
      var gewaehlt = s.options[s.selectedIndex];
      if (s.value && gewaehlt && gewaehlt.disabled) s.value = '';
    });
    sel = auswahl(row);

    row.querySelectorAll('[data-swatch]').forEach(function (b) {
      var idx = parseInt(b.getAttribute('data-index'), 10);
      var val = b.getAttribute('data-value');
      var ok = vs.some(function (v) { return v.available && v.options[idx] === val && passt(v, sel, idx); });
      var an = sel[idx] === val;
      b.classList.toggle('is-unavailable', !ok);
      b.classList.toggle('is-selected', an);
      b.setAttribute('aria-pressed', an ? 'true' : 'false');
    });
    row.querySelectorAll('[data-farbname]').forEach(function (el) {
      var idx = parseInt(el.getAttribute('data-index'), 10);
      if (sel[idx]) el.textContent = farbname(sel[idx]);
    });

    var komplett = sel.length > 0 && sel.every(function (x) { return !!x; });
    var treffer = komplett ? vs.filter(function (v) { return passt(v, sel, -1); })[0] : null;
    var anzeige = treffer ||
      vs.filter(function (v) { return v.available && passt(v, sel, -1); })[0] ||
      vs.filter(function (v) { return passt(v, sel, -1); })[0] || vs[0];

    if (anzeige) {
      row.setAttribute('data-cents', anzeige.price);
      var preis = row.querySelector('[data-teil-preis]');
      if (preis) {
        var vergleich = anzeige.compare_at_price && anzeige.compare_at_price > anzeige.price;
        preis.innerHTML = (vergleich ? '<s>' + geld(anzeige.compare_at_price) + '</s> ' : '') + geld(anzeige.price);
      }
      var img = row.querySelector('.outfit-teil__img');
      var src = anzeige.featured_image && anzeige.featured_image.src ? bildUrl(anzeige.featured_image.src, 400) : '';
      if (img && src && img.getAttribute('data-aktuell') !== src) {
        if (img.getAttribute('data-aktuell')) { img.removeAttribute('srcset'); img.src = src; }
        img.setAttribute('data-aktuell', src);
      }
    }

    var verfuegbar = !!(treffer && treffer.available);
    row.setAttribute('data-variant-id', verfuegbar ? treffer.id : '');
    if (verfuegbar && row.classList.contains('braucht-groesse')) {
      row.classList.remove('braucht-groesse');
      nachricht(row.querySelector('[data-teil-msg]'), '', false);
    }
  }
  function summeAktualisieren(root) {
    if (!root) return;
    var aktiv = teile(root).filter(function (r) { return !r.classList.contains('is-vergriffen'); });
    var summe = aktiv.reduce(function (s, r) { return s + (parseInt(r.getAttribute('data-cents'), 10) || 0); }, 0);
    root.querySelectorAll('[data-outfit-summe]').forEach(function (el) { el.textContent = geld(summe); });
    var btn = root.querySelector('[data-outfit-alle]');
    if (btn) btn.disabled = aktiv.length === 0;
  }

  /* ---------- Warenkorb ---------- */
  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }
  function hinzufuegen(root, rows, btn, msgEl) {
    var fehlend = rows.filter(function (r) { return !r.getAttribute('data-variant-id'); });
    if (fehlend.length) {
      fehlend.forEach(function (r) {
        r.classList.add('braucht-groesse');
        nachricht(r.querySelector('[data-teil-msg]'), 'Bitte wähle deine Größe.', false);
      });
      var erstes = fehlend[0];
      erstes.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var s = erstes.querySelector('select[data-opt]');
      if (s) setTimeout(function () { try { s.focus({ preventScroll: true }); } catch (e) { s.focus(); } }, 450);
      return;
    }
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    nachricht(msgEl, '', false);

    var body = {
      items: rows.map(function (r) {
        return { id: parseInt(r.getAttribute('data-variant-id'), 10), quantity: 1, properties: { _quelle: 'outfit-seite', _outfit: root.getAttribute('data-handle') } };
      })
    };
    var ids = cartSectionIds();
    if (ids.length) body.sections = ids.join(',');

    fetch(root.getAttribute('data-cart-add-url') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'Konnte nicht in den Warenkorb gelegt werden.');
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: {}, sourceId: 'outfit-seite', data: { source: 'product-form-component', itemCount: rows.length, sections: res.sections || {} } }
        }));
        var drawer = document.querySelector('cart-drawer-component');
        if (!drawer) { window.location.href = root.getAttribute('data-cart-url'); return; }
        if (typeof drawer.open === 'function' && !drawer.hasAttribute('auto-open')) drawer.open();
        nachricht(msgEl, rows.length > 1 ? 'Dein Outfit liegt im Warenkorb.' : 'Liegt im Warenkorb.', true);
      })
      .catch(function (err) {
        nachricht(msgEl, (err && err.message) || 'Konnte nicht in den Warenkorb gelegt werden.', false);
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      });
  }

  /* ---------- Events ---------- */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-outfit-chip]');
    if (chip) { filtern(chip); return; }

    var sw = e.target.closest('[data-swatch]');
    if (sw) {
      var row = sw.closest('[data-outfit-teil]');
      var input = row.querySelector('input[data-opt][data-index=\'' + sw.getAttribute('data-index') + '\']');
      if (input) input.value = sw.getAttribute('data-value');
      zeileAktualisieren(row);
      summeAktualisieren(row.closest('[data-outfit]'));
      return;
    }

    var einzeln = e.target.closest('[data-outfit-einzeln]');
    if (einzeln) {
      var r = einzeln.closest('[data-outfit-teil]');
      hinzufuegen(r.closest('[data-outfit]'), [r], einzeln, r.querySelector('[data-teil-msg]'));
      return;
    }

    var alle = e.target.closest('[data-outfit-alle]');
    if (alle) {
      var root = alle.closest('[data-outfit]');
      var rows = teile(root).filter(function (x) { return !x.classList.contains('is-vergriffen'); });
      hinzufuegen(root, rows, alle, root.querySelector('[data-outfit-msg]'));
    }
  });

  document.addEventListener('change', function (e) {
    var s = e.target.closest ? e.target.closest('select[data-opt]') : null;
    if (!s) return;
    var row = s.closest('[data-outfit-teil]');
    if (!row) return;
    zeileAktualisieren(row);
    summeAktualisieren(row.closest('[data-outfit]'));
  });

  /* ---------- Galerie (mobil wischen, Punkte) ---------- */
  function galerieInit(g) {
    if (g.__init) return;
    g.__init = true;
    var spur = g.querySelector('[data-galerie-spur]');
    var punkte = g.querySelectorAll('[data-galerie-punkt]');
    if (!spur || !punkte.length) return;
    var setzen = function () {
      var i = Math.round(spur.scrollLeft / Math.max(1, spur.clientWidth));
      punkte.forEach(function (p, j) { p.setAttribute('aria-current', i === j ? 'true' : 'false'); });
    };
    spur.addEventListener('scroll', function () { window.requestAnimationFrame(setzen); }, { passive: true });
    punkte.forEach(function (p, j) {
      p.addEventListener('click', function () { spur.scrollTo({ left: j * spur.clientWidth, behavior: 'smooth' }); });
    });
  }

  function init() {
    document.querySelectorAll('[data-galerie]').forEach(galerieInit);
    document.querySelectorAll('[data-outfit]').forEach(function (root) {
      teile(root).forEach(zeileAktualisieren);
      summeAktualisieren(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
